import { Network } from 'lucide-react'
import { Card, EmptyState, MoneyValue } from '@shared/design-system/ui'
import type { DashboardCurrencyOverview } from '../api/dashboard.contract'
import {
  detailLabel,
  detailRow,
  detailValue,
  inlineList,
  productMeta,
  sectionHeader,
  sectionTitle,
} from './dashboard.css'

interface OriginAnalyticsProps {
  currencyData: DashboardCurrencyOverview
}

function formatPct(value: number): string {
  return `${value.toLocaleString('pt-BR', { maximumFractionDigits: 1 })}%`
}

function affiliateLabel(affiliateId: string): string {
  if (affiliateId.includes('@')) {
    return affiliateId
  }

  const compact = affiliateId.replace(/[^a-zA-Z0-9]/g, '').slice(-6)
  return compact ? `Afiliado #${compact}` : 'Afiliado'
}

export function OriginAnalytics({ currencyData }: OriginAnalyticsProps) {
  return (
    <Card padding="md">
      <div className={sectionHeader}>
        <span className={sectionTitle}>Origem</span>
      </div>

      <div className={inlineList}>
        <div className={detailRow}>
          <span className={detailLabel}>Diretas</span>
          <span className={detailValue}>
            {currencyData.originBreakdown.direct.salesCount} cobranças pagas ·{' '}
            {formatPct(currencyData.originBreakdown.direct.pct)}
          </span>
          <MoneyValue
            amount={currencyData.originBreakdown.direct.amount.amount}
            currency={currencyData.originBreakdown.direct.amount.currency}
            size="sm"
          />
        </div>
        <div className={detailRow}>
          <span className={detailLabel}>Afiliadas</span>
          <span className={detailValue}>
            {currencyData.originBreakdown.affiliate.salesCount} cobranças pagas ·{' '}
            {formatPct(currencyData.originBreakdown.affiliate.pct)}
          </span>
          <MoneyValue
            amount={currencyData.originBreakdown.affiliate.amount.amount}
            currency={currencyData.originBreakdown.affiliate.amount.currency}
            size="sm"
          />
        </div>
        {currencyData.originBreakdown.topAffiliates.length > 0 ? (
          currencyData.originBreakdown.topAffiliates.map((affiliate) => (
            <div key={affiliate.affiliateId} className={detailRow}>
              <span className={detailLabel}>{affiliateLabel(affiliate.affiliateId)}</span>
              <span className={productMeta}>{affiliate.salesCount} cobranças pagas</span>
              <MoneyValue
                amount={affiliate.revenue.amount}
                currency={affiliate.revenue.currency}
                size="sm"
              />
            </div>
          ))
        ) : (
          <EmptyState
            icon={<Network size={22} />}
            title="Sem afiliados no período"
            description="Cobranças por afiliado aparecem aqui quando houver origem com comissão."
          />
        )}
      </div>
    </Card>
  )
}
